import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";
import { ContainerTypeEligibilityRulesDeleteResponseType } from "@sellar-io/api-v2/types";

export const useContainerTypeEligibilityRulesDelete = (
  containerTypeEligibilityRulesId: number,
) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: () =>
      apiV2Request({
        user,
        business,
        method: "delete",
        path: `container-type-eligibility-rules/${containerTypeEligibilityRulesId}`,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as ContainerTypeEligibilityRulesDeleteResponseType,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.FulfillmentType],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.FulfillmentType],
      });
    },
  });
};
